<template>
  <div class="install-page">
    <div class="install-container">
      <div class="install-header">
        <h1>社区专送跑腿管理后台</h1>
        <p>首次安装引导</p>
      </div>

      <div v-if="loading" class="install-tip">正在检测安装状态...</div>

      <div v-else-if="installed" class="install-tip">
        <p>系统已初始化，无需重复安装。</p>
        <button class="install-btn" @click="goLogin">前往登录</button>
      </div>

      <form v-else class="install-form" @submit.prevent="handleSubmit">
        <p class="install-desc">
          检测到后台尚未创建管理员账号，请先设置首个超级管理员。
        </p>
        <div class="form-group">
          <label>登录账号</label>
          <input
            type="text"
            v-model="form.username"
            placeholder="请输入管理员账号"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>登录密码</label>
          <input
            type="password"
            v-model="form.password"
            placeholder="至少6位"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>确认密码</label>
          <input
            type="password"
            v-model="form.confirm"
            placeholder="再次输入密码"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>真实姓名（选填）</label>
          <input
            type="text"
            v-model="form.real_name"
            placeholder="如：系统管理员"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <label>手机号（选填）</label>
          <input
            type="text"
            v-model="form.phone"
            placeholder="请输入手机号"
            class="form-control"
          />
        </div>
        <button type="submit" class="install-btn">完成初始化</button>
      </form>

      <div class="install-footer">
        <span @click="goLogin">已有账号？返回登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getInstallStatus, installAdmin } from '@/api/system'

export default {
  name: 'Install',
  data() {
    return {
      loading: true,
      installed: false,
      form: {
        username: '',
        password: '',
        confirm: '',
        real_name: '',
        phone: ''
      }
    }
  },
  async created() {
    try {
      const res = await getInstallStatus()
      if (res.code === 0 && res.data) {
        this.installed = !!res.data.installed
      }
    } catch (e) {
      // 检测失败按未安装处理，允许尝试安装
    } finally {
      this.loading = false
    }
  },
  methods: {
    goLogin() {
      this.$router.push('/login')
    },
    async handleSubmit() {
      const { username, password, confirm } = this.form
      if (!username || !password) {
        alert('请输入账号和密码')
        return
      }
      if (password.length < 6) {
        alert('密码至少6位')
        return
      }
      if (password !== confirm) {
        alert('两次输入的密码不一致')
        return
      }
      try {
        const res = await installAdmin(this.form)
        if (res.code !== 0) {
          alert(res.message || '初始化失败')
          return
        }
        alert('初始化成功，请使用新账号登录')
        this.$router.push('/login')
      } catch (err) {
        const msg = err && err.response && err.response.data && err.response.data.message
        alert(msg || '初始化失败，请稍后重试')
      }
    }
  }
}
</script>

<style scoped>
.install-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.install-container {
  background: #fff;
  border-radius: 16px;
  padding: 40px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.install-header {
  text-align: center;
  margin-bottom: 30px;
}

.install-header h1 {
  margin: 0 0 10px 0;
  font-size: 24px;
  color: #333;
}

.install-header p {
  margin: 0;
  color: #999;
  font-size: 14px;
}

.install-desc {
  background: #f5f6fa;
  color: #666;
  font-size: 13px;
  padding: 12px 14px;
  border-radius: 8px;
  margin: 0 0 20px 0;
  line-height: 1.6;
}

.install-tip {
  text-align: center;
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 18px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.form-control {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s;
  box-sizing: border-box;
}

.form-control:focus {
  outline: none;
  border-color: #667eea;
}

.install-btn {
  width: 100%;
  padding: 14px;
  margin-top: 6px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.3s;
}

.install-btn:hover {
  opacity: 0.9;
}

.install-footer {
  text-align: center;
  margin-top: 20px;
}

.install-footer span {
  color: #667eea;
  font-size: 14px;
  cursor: pointer;
}
</style>
